import L from 'leaflet';

const _createButton = L.Control.Zoom.prototype._createButton;

L.Control.Zoom.prototype._createButton = function(...args) {

    const link = _createButton.call(this, ...args);

    // Remote the href='#' attribute and use tabindex instead.

    link.removeAttribute('href');
    link.setAttribute('tabindex', 0);

    return link;
};



// WEBPACK FOOTER //
// ./src/components/leaflet/L.Control.Zoom.js